import React from "react";
import Context from "../../../Context";
import EssenceActionsDropdown from "../../Essence/EssenceActionsDropdown";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";
import EssenceFiles from "../../Essence/EssenceFiles";
import Blocker from "../../Misc/Blocker";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import SuperSelect from "../../Misc/SuperSelect";
import FormLine from "../../Misc/FormLine";
import ElementPicker from "../../Misc/ElementPicker";
import EssenceReference from "../../Essence/EssenceReference";
import Select from "react-select";
import ModelPicker from "../../Misc/ModelPicker";

export default class Repair extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      item: {},
      lines: [],

      elementPickIdx: false,
      elementPickShow: false,

      modelPickIdx: false,
      modelPickShow: false,

      structureItems: {},
      structurePickIdx: false,
      structurePickShow: false,

      mode: "items",
    };
  }

  componentDidMount() {
    this.loadReferences().then(() => this.load());
    this.renderButtons();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.docId !== this.props.docId) {
      this.load();
    }
    this.renderButtons();
  }

  onChange = (id, value) => {
    this.setState((state) => {
      let { item } = state;
      item[id] = value;
      return { item };
    });
  };

  onLineChange = (idx, key, value) => {
    let { lines } = this.state;
    lines[idx][key] = value;
    this.setState({ lines });
  };

  loadReferences = async () => {
    this.setState({ pending: true });
    let elements = {};
    let models = {};
    let measure = await this.context.api.qrc("/measure/list");
    let currency = await this.context.api.qrc("/currency/list");

    this.setState({ pending: false, elements, models, measure, currency });
  };

  rowAdd = (idx) => {
    let { lines } = this.state;
    let index = idx || 0;
    lines.splice(index, 0, {});
    this.setState({ lines });
  };

  rowRemove = (idx) => {
    let { lines } = this.state;
    lines.splice(idx, 1);
    this.setState({ lines });
  };

  load = async () => {
    const { docId } = this.props;
    this.setState({ pending: true, notFound: false });
    if (docId && docId !== "add") {
      let item = await this.context.api.q("/repair/get", { id: docId });
      if (!item) {
        this.setState({ notFound: true });
      } else {
        let lines = await this.context.api.qa("/repair/item/list", {
          filter: { documentid: docId },
          orderby: ["itemid ASC"],
        });

        this.setState({ item, lines: lines || [] });
      }
    } else {
      let lines = [];
      let searchParams = new URLSearchParams(
        this.props.location.search.substr(1)
      );
      let append = searchParams.get("append");
      if (append) {
        let appendItems = append.split(",");
        appendItems.forEach((id) => {
          lines.push({ elementid: id });
        });
      }

      this.setState({ item: {}, lines });
    }
    this.setState({ pending: false });
    this.context.force();
  };

  save = async () => {
    let docId = null;
    if (this.props.docId && this.props.docId !== "add") {
      docId = this.props.docId;
    }

    const { item } = this.state;
    this.setState({ pending: true });
    let saveData = {
      id: docId,
      ship: item.ship,
      description: item.description,
    };
    let result = await this.context.api.q("/repair/set", saveData);

    if (result !== false) {
      let items = [];
      let { lines } = this.state;
      lines.forEach((line) => {
        items.push({
          elementid: line.elementid,
          modelid: line.modelid,
          measureid: line.measureid,
          currencyid: line.currencyid,
          volume: line.volume,
          price: line.price,
          structureid: line.structureid,
          description: line.description,
          overhaul: line.overhaul ? true : false,
        });
      });

      let itemsResult = await this.context.api.q("/repair/item", {
        items,
        document: result.id,
      });
      if (itemsResult !== false) {
        this.context.toast("Изменения сохранены", "success");

        if (this.props.docId === "add") {
          this.setState({ pending: false });
          this.context.redirect(`/repair/${result.id}`);
        } else {
          this.load();
        }
      } else {
        this.setState({ pending: false });
        this.context.toast("Не удалось сохранить изменения", "error");
      }
    } else {
      this.setState({ pending: false });
      this.context.toast("Не удалось сохранить изменения", "error");
    }
  };

  new = () => {
    this.setState({ lines: [] });
    this.context.redirect("/repair/add");
  };

  open = () => {
    const { docId } = this.props;
    if (docId && docId !== "add") {
      this.context.redirect(`/workdoc/any/any/${docId}`);
    } else {
      this.context.redirect("/workdoc/");
    }
  };

  renderButtons = () => {
    this.context.actionsSet(
      <>
        <button
          title="Новый"
          onClick={this.new}
          className={`btn btn-icon btn-light mr-2`}
        >
          <i className="fa fa-file-o"></i>
        </button>
        <button
          title="Сохранить"
          onClick={this.save}
          className={`btn btn-icon btn-light mr-2`}
        >
          <i className="fa fa-save"></i>
        </button>
        <button
          title="Открыть"
          onClick={this.open}
          className={`btn btn-icon btn-light mr-2`}
        >
          <i className="fa fa-folder-open-o"></i>
        </button>
      </>
    );
  };

  onElementPickOpen = (idx) => {
    this.setState({ elementPickShow: true, elementPickIdx: idx });
  };

  onElementPickClose = () => {
    this.setState({ elementPickShow: false });
  };

  onElementPick = (elem) => {
    this.setState(
      ({ elements }) => {
        elements[elem.id] = elem;
        return elements;
      },
      () => this.onLineChange(this.state.elementPickIdx, "elementid", elem.id)
    );
  };

  onModelPickOpen = (idx) => {
    this.setState({ modelPickShow: true, modelPickIdx: idx });
  };

  onModelPickClose = () => {
    this.setState({ modelPickShow: false });
  };

  onModelPick = (model) => {
    this.setState(
      ({ models }) => {
        models[model.id] = model;
        return models;
      },
      () => this.onLineChange(this.state.modelPickIdx, "modelid", model.id)
    );
  };

  getElementLabel = (id, defaultLabel = "") => {
    let result = defaultLabel;
    if (this.state.elements[id]) {
      result = `${this.state.elements[id].label}`;
    }
    return result;
  };

  getModelLabel = (id, defaultLabel = "") => {
    let result = defaultLabel;
    if (this.state.models[id]) {
      result = `${this.state.models[id].label}`;
    }
    return result;
  };

  getStructureLabel = (id) => {
    let result = "";
    let item = this.state.structureItems[`_${id}`];
    if (item) {
      result = `${item.label}`;
    }
    return result;
  };

  onStructurePickClose = () => {
    this.setState({ structurePickShow: false });
  };

  onStructurePickOpen = (idx) => {
    this.setState({ structurePickShow: true, structurePickIdx: idx });
  };

  onStructureLoad = (structureItems) => {
    this.setState({ structureItems });
  };

  onStructurePick = (item) => {
    this.onLineChange(this.state.structurePickIdx, "structureid", item.id);
  };

  onCreateModel = async (model) => {
    this.setState(
      (state) => {
        let { models } = state;
        models[model.id] = { label: model.label };
        return { models };
      },
      () => this.onLineChange(this.state.modelPickIdx, "modelid", model.id)
    );
  };

  modeSwith = (mode) => {
    this.setState({ mode });
  };

  render() {
    const { item, notFound, pending, lines, mode } = this.state;
    const { docId } = this.props;
    let title = docId === "add" ? "Новая ремонтная ведомость" : item.label;
    let canLoadFiles = false;
    if (docId && docId !== "add") canLoadFiles = true;

    if (notFound) {
      title = "Документ не найден";
      return (
        <div className="container">
          <CrumbsProvider title={title} link="/repair/" />
          <DefaultNotFound />
        </div>
      );
    }

    return (
      <>
        <ElementPicker
          onElementPick={this.onElementPick}
          onClose={this.onElementPickClose}
          show={this.state.elementPickShow}
          shipId={item.ship}
          keepModal
        />
        <ModelPicker
          onModelPick={this.onModelPick}
          onClose={this.onModelPickClose}
          onCreate={this.onCreateModel}
          show={this.state.modelPickShow}
          allowCreate
          keepModal
        />
        <EssenceReference
          essence="structure"
          sort="sequence"
          forceType="repair.structure"
          title="Виды и типы работ"
          showDescription
          draggable
          structure
          show={this.state.structurePickShow}
          onHide={this.onStructurePickClose}
          onAfterLoad={this.onStructureLoad}
          onSelect={this.onStructurePick}
        />
        <CrumbsProvider title={title} link={`/repair/${item.id}/`} />
        <div className="container h-100">
          <div className="row  h-100">
            <div className="col">
              <div className="card card-custom card-stretch">
                <Blocker on={pending}>
                  <div className="card-body px-5 py-5">
                    <div className="dochat">
                      <div className="flex-grow-1">
                        <div className="row">
                          <div className="col-6">
                            <FormLine label="Судно:">
                              <SuperSelect
                                defaultValue={item.ship}
                                onChange={(value) =>
                                  this.onChange("ship", value)
                                }
                                onSingleItem={(item) =>
                                  this.onChange("ship", item.value)
                                }
                                essence="ship"
                                placeholder="Выберите..."
                                nameField="name"
                                idField="id"
                              />
                            </FormLine>
                          </div>

                          <div className="col-6 ">
                            <FormLine label="Комментарий:">
                              <input
                                type="text"
                                value={item.description || ""}
                                onChange={(e) =>
                                  this.onChange("description", e.target.value)
                                }
                                className="form-control"
                              />
                            </FormLine>
                          </div>
                        </div>
                      </div>

                      {item.id && (
                        <div className="d-flex align-items-center ml-3">
                          <EssenceStateLabel
                            stateCode={item.statetypecode}
                            stateLabel={item.statelabel}
                            essence="repair"
                            id={item.id}
                            onAfterStateChanged={(c) => {
                              if (c === "enabled") {
                                this.open();
                              }
                            }}
                          />
                          <EssenceActionsDropdown
                            essence={"repair"}
                            key={item.id}
                            id={item.id}
                            label={item.label}
                            onFinish={this.load}
                          />
                        </div>
                      )}
                    </div>
                    <ul className="nav nav-tabs mb-4">
                      <li
                        className={`cursor-pointer nav-link ${
                          mode === "items" && "active"
                        }`}
                        onClick={() => this.modeSwith("items")}
                      >
                        <i
                          title="Добавить строку"
                          onClick={() => this.rowAdd()}
                          className="fa fa-plus cursor-pointer text-hover-primary mr-2"
                        ></i>
                        Записи ведомости
                      </li>
                      <li
                        className={`cursor-pointer nav-link ${
                          mode === "files" && "active"
                        }`}
                        onClick={() => this.modeSwith("files")}
                      >
                        Прикрепленные документы
                      </li>
                    </ul>
                    {mode === "items" && (
                      <table className="table">
                        <tbody>
                          {lines.map((item, idx) => {
                            let line = item || {};
                            return (
                              <tr key={idx}>
                                <td>
                                  <div className="d-flex align-items-center mt-3">
                                    <div className="flex-grow-1">
                                      <div className="row">
                                        <div className="col mb-3">
                                          <div className="input-group">
                                            <input
                                              readOnly
                                              type="text"
                                              className="form-control bg-light"
                                              placeholder="Вид, тип работ..."
                                              value={
                                                idx +
                                                1 +
                                                ". " +
                                                this.getStructureLabel(
                                                  line.structureid
                                                )
                                              }
                                              onDoubleClick={() =>
                                                this.onStructurePickOpen(idx)
                                              }
                                            />
                                            <div className="input-group-append">
                                              <button
                                                title="Выбрать"
                                                className="btn btn-icon border"
                                                type="button"
                                                onClick={() =>
                                                  this.onStructurePickOpen(idx)
                                                }
                                              >
                                                <i className="fa icon-md text-muted fa-navicon"></i>
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col mb-3">
                                          <div className="input-group">
                                            <input
                                              readOnly
                                              type="text"
                                              className="form-control"
                                              placeholder="К оборудованию"
                                              value={this.getElementLabel(
                                                line.elementid,
                                                line?.element?.label
                                              )}
                                              onDoubleClick={() =>
                                                this.onElementPickOpen(idx)
                                              }
                                            />
                                            <div className="input-group-append">
                                              <button
                                                title="Выбрать"
                                                className="btn btn-icon border"
                                                type="button"
                                                onClick={() =>
                                                  this.onElementPickOpen(idx)
                                                }
                                              >
                                                <i className="fa icon-md text-muted fa-navicon"></i>
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="ml-3 text-nowrap">
                                      <i
                                        title="Удалить строку"
                                        onClick={() => this.rowRemove(idx)}
                                        className="fa fa-times cursor-pointer text-hover-danger "
                                      ></i>
                                      <i
                                        title="Добавить строку ниже"
                                        onClick={() => this.rowAdd(idx + 1)}
                                        className="fa fa-plus cursor-pointer text-hover-primary ml-2"
                                      ></i>
                                    </div>
                                  </div>
                                  <div className="mb-3">
                                    <div className="row">
                                      <div className="col-8">
                                        <input
                                          className="form-control"
                                          value={line.description || ""}
                                          placeholder="Описание..."
                                          onChange={(e) =>
                                            this.onLineChange(
                                              idx,
                                              "description",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                      <div className="col-2">
                                        <input
                                          className="form-control"
                                          value={item.price || ""}
                                          size={3}
                                          type="number"
                                          placeholder="Цена работ"
                                          onChange={(e) =>
                                            this.onLineChange(
                                              idx,
                                              "price",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                      <div className="col-2">
                                        <Select
                                          isClearable
                                          value={this.context.api.getReferenceValue(
                                            line.currencyid,
                                            this.state.currency
                                          )}
                                          onChange={(result) =>
                                            this.onLineChange(
                                              idx,
                                              "currencyid",
                                              result ? result.value : null
                                            )
                                          }
                                          className="from-control react-select"
                                          classNamePrefix="react-select-inner"
                                          options={this.state.currency}
                                          placeholder="Вал."
                                          noOptionsMessage={({ inputValue }) =>
                                            `Ничего не найдено по запросу ${inputValue}`
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="mb-3">
                                    <div className="row">
                                      <div className="col-8">
                                        <div className="input-group">
                                          <input
                                            readOnly
                                            type="text"
                                            className="form-control"
                                            placeholder="ЗИП"
                                            value={this.getModelLabel(
                                              line.modelid,
                                              line?.model?.name
                                            )}
                                            onDoubleClick={() =>
                                              this.onModelPickOpen(idx)
                                            }
                                          />
                                          <div className="input-group-append">
                                            <button
                                              title="Выбрать"
                                              className="btn btn-icon border"
                                              type="button"
                                              onClick={() =>
                                                this.onModelPickOpen(idx)
                                              }
                                            >
                                              <i className="fa icon-md text-muted fa-navicon"></i>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-2">
                                        <input
                                          placeholder="Кол-во"
                                          className="form-control"
                                          value={item.volume || ""}
                                          size={3}
                                          type="number"
                                          onChange={(e) =>
                                            this.onLineChange(
                                              idx,
                                              "volume",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                      <div className="col-2">
                                        <Select
                                          isClearable
                                          value={this.context.api.getReferenceValue(
                                            line.measureid,
                                            this.state.measure
                                          )}
                                          onChange={(result) =>
                                            this.onLineChange(
                                              idx,
                                              "measureid",
                                              result ? result.value : null
                                            )
                                          }
                                          className="from-control react-select"
                                          classNamePrefix="react-select-inner"
                                          options={this.state.measure}
                                          placeholder="ед."
                                          noOptionsMessage={({ inputValue }) =>
                                            `Ничего не найдено по запросу ${inputValue}`
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="mt-3">
                                    <label className="checkbox">
                                      <input
                                        type="checkbox"
                                        id="overhaul"
                                        onChange={(e) =>
                                          this.onLineChange(
                                            idx,
                                            "overhaul",
                                            e.target.checked
                                          )
                                        }
                                        checked={line.overhaul}
                                      />
                                      <span className="mr-2"></span>
                                      Капитальный ремонт
                                    </label>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    )}
                    {mode === "files" && (
                      <div>
                        {canLoadFiles && (
                          <EssenceFiles
                            essence="repair"
                            id={this.props.docId}
                            key={this.props.docId}
                          />
                        )}
                        {!canLoadFiles && (
                          <div className="alert alert-light mt-4">
                            Чтобы прикрепить файлы сначала нужно сохранить
                            ведомость
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </Blocker>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
